import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid",
  alt: "Zed logo",
  src: _imports_0
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Zed Projects", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Currently work in progress", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createTextVNode(" TODO: "),
  /*#__PURE__*/_createElementVNode("li", null, " Implement selecting project from database rather than just displaying placeholder data ")
], -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_6))
}